import { makeContextualPopupApi } from '../utils/plugin'
import alert from '../managers/alert'

export default makeContextualPopupApi('alert', alert)
